<template>
    <div class="app-not-found">
        <img src="/svg/404.svg" width="300px">
        <mu-title color="primary">Página não foi encontrada</mu-title>
        <p>Desculpe, mas a página que você tentou acessar não existe.</p>
        <mu-button round color="primary" :to="{ name: 'auth.login' }">Ir para o início</mu-button>
    </div>
</template>

<script>
    export default {
        name: 'app-not-found-unauthenticated',
        computed: {
            authenticated () {
                return this.$store.state.authenticated
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../../assets/stylus/bootstrap.styl'

    .app-not-found
        text-align center
        padding 50px 0
        color $grey

</style>
